/* eslint-disable import/no-cycle */
import { makeServiceCall } from 'redux-core/serviceHelpers';

export const getUserProfileCall = makeServiceCall('users', 'profile');
export const updateUserPreferredDivisionContact = makeServiceCall('users', 'set-preferred-division-contact');
export const updateUserProfileCall = makeServiceCall('users', 'update');
export const updateUserPasswordCall = makeServiceCall('users', 'change-password');
